import React from "react";

export const GFFrame = ({ children, testId = "gf-frame" }) => (
  <div className="gf-stage">
    <div className="gf-frame font-body" data-testid={testId}>
      {children}
    </div>
  </div>
);

export const GFHeader = () => (
  <div className="flex items-center justify-center gap-2 pt-7 pb-2">
    <span className="font-heading text-lg font-bold tracking-[0.3em] text-[#0F172A]">
      GROWTH
    </span>
    <span className="h-1.5 w-1.5 rounded-full bg-[#D4AF37]" />
    <span className="font-heading text-lg font-bold tracking-[0.3em] text-[#D4AF37]">
      FACTOR
    </span>
  </div>
);
